import styled from '@emotion/styled'

export const HorizontalLine = styled.hr(props => ({
  borderTopWidth: '0px',
  borderBottom: `1px solid ${props.theme.primaryColor}`,
  margin: '0',
}))
